<template>
  <div class="invitation">
    <div class="in-bg">
      <div class="top-text">
        <span>{{msg}}</span>
      </div>
      <div class="in-text-con" v-if="code != 600">
        <span class="center-text">邀请一位新人可获得</span>
        <div class="center-money">{{ Number(now_obj.balance) }} 元</div>
        <div class="center-money">{{ Number(now_obj.point) }} 积分</div>
        <div class="center-money">优惠券 {{ now_obj.con_num }} 张</div>
      </div>
      <!-- <div class="push-btn">
        <img src="@static/vip/yaoqing_btn.png" alt="">
      </div> -->
      <div class="center-user" v-if="code != 600">
        <div>
          <!-- <img src="@static/vip/user_2.png" alt=""> -->
        </div>
        <div class="center-con">
          <router-link to="invitation">
            <span class="go-oil">邀请他人</span>
          </router-link>
          <router-link to="vipShopList">
            <span class="go-oil">去加油</span>
          </router-link>
        </div>
        <div>
          <!-- <img src="@static/vip/user_1.png" alt=""> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getUrlArgObject } from "@/utils/tools";
import UserInfo from "@/api/user";
export default {
  data() {
    return {
      msg: "",
      now_obj: {},
      code: ""
    }
  },
  created() {
    var url = decodeURI(window.location);
    this.msg = getUrlArgObject(url).msg;
    this.code = getUrlArgObject(url).code
    if (this.code != '600') this.getMoney();
  },
  methods: {
    // 获取礼品
    async getMoney() {
      try {
        const res = await UserInfo.getInviteCode();
        res.data.con_num = res.data.coupon.length;
        if (res.code == 200) this.now_obj = res.data;
      } catch (error) {
        console.log(error);
      }
    },
  }
}
</script>
<style scoped>
.invitation {
  width: 100%;
  height: 100vh;
  display: flex;
  background:#fbce7f;
  flex-direction: column;
}
.top-text {
  width: 340px;
  height: 80px;
  font-size: 24px;
  font-weight: 400;
  margin: 40px auto;
  text-align: center;
  color: #f7f7ee;
  font-family: 'kaiti';
}

.in-bg {
  width: 100%;
  height: 500px;
  position: relative;
  background: url('../../../../../../public/static/images/vip/top_bg_banner.png') no-repeat;
  background-size: cover;
  background-position: 40% 0;
}
.in-text-con {
  width: 230px;
  height: 240px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.center-text {
  color: #F82633;
  font-size: 16px;
}
.center-money {
  margin-top: 10px;
  font-size: 50px;
  color: #F82633;
  font-weight: 560;
}
.center-money {
  margin-top: 10px;
  font-size: 16px;
  color: #F82633;
  font-weight: 560;
}
.push-btn {
  width: 180px;
  margin: 10px auto;
}
.push-btn img {
  width: 100%;
  height: 100%;
}
.go-oil {
  width: 100px;
  height: 30px;
  display: inline-block;
  line-height: 30px;
  border-radius: 25px;
  margin-top: 10px;
  font-size: 14px;
  text-align: center;
  color: #f7f7ee;
  margin-top: 20px;
  background: none;
  border: 1px solid #fbd46d;
}
.center-user {
  width: 100%;
  display: flex;
  padding: 0 20px;
  margin-top: -22px;
  justify-content: space-between;
}
.center-user div {
  width: 90px;
  z-index: 100;
}
.center-user div img {
  width: 100%;
  height: 100%;
}
.used-text {
  width: 60%;
  height: 24px;
  line-height: 24px;
  position: absolute;
  bottom: 10px;
  text-align: center;
  color: #fff;
  background:rgba(165,9,7,1);
  border-radius:23px;
  left: 50%;
  margin-left: -30%;
  /* background-color: rgba(255, 255, 255, .1) */
}
.active-item {
  width: 100%;
  height: 300px;
  display: flex;
  margin-top: 120px;
  align-items: center;
  flex-direction: column;
}
.active-item-title {
  width: 280px;
  height: 40px;
  background:linear-gradient(90deg,rgba(253,171,7,1) 0%,rgba(234,12,20,1) 49%,rgba(253,171,7,1) 100%);
  box-shadow: 0px 9px 18px 0px rgba(236,31,19,0.26);
  border-radius: 5px;
  font-size: 18px;
  font-weight:500;
  color:rgba(255,255,255,1);
  text-align: center;
  line-height: 40px;
  z-index: 100;
}
.my-items {
  width: 100%;
  display: flex;
}
.active-item-con {
  width: 330px;
  height: 180px;
  background:rgba(255,255,255,1);
  box-shadow: 0px 9px 18px 0px rgba(250,160,3,0.26);
  border-radius:10px;
  z-index: 50;
  margin-top: -10px;
  display: flex;
  flex-direction: column;
}
.act-item {
  flex: 1;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  margin-top: 30px;
}
.act-item span:nth-child(1) {
  color: #1A053C;
  font-size: 15px;
}
.act-item span:nth-child(2) {
  color:rgba(26,5,60,1);
  font-size: 30px;
}
.act-item:last-child span:nth-child(2) {
  color:#EB1813;
  font-size: 30px;
}
.get-detail {
  width: 180px;
  height: 44px;
  border: 1px solid rgba(234,13,20,1);
  border-radius: 22px;
  text-align: center;
  line-height: 44px;
  margin: 10px auto;
  color: #EB1813;
  font-weight:500;
  font-size: 18px;
}
.center-con {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
}
</style>
